import { createSlice } from '@reduxjs/toolkit';
import { AppState } from '@app/store/state/app.state';
import { getParameterByName } from '@shared/utils/UrlUtils';
import { CompanyInformationView } from './CompanyManagement.model';

function getActivePanelWithFallback(): CompanyInformationView {
  const param = getParameterByName('panel', window.location.href);
  const parsed = param ? parseInt(param) : NaN;
  return Number.isNaN(parsed) ? CompanyInformationView.General : parsed;
}

export interface EditCompanyLayout {
  activePanel: CompanyInformationView;
}

export const initialEditCompanyLayout: EditCompanyLayout = {
  activePanel: getActivePanelWithFallback(),
}

const editCompanyLayoutSlice = createSlice({
  name: 'editCompanyLayout',
  initialState: initialEditCompanyLayout,
  reducers: {
    resetEditCompanyLayout: () => ({...initialEditCompanyLayout, activePanel: CompanyInformationView.General}),
    setActivePanel: (state, action) => ({...state, activePanel: action.payload}),
  },
});

export default editCompanyLayoutSlice.reducer;
export const {
  resetEditCompanyLayout,
  setActivePanel,
} = editCompanyLayoutSlice.actions;

export const selectActivePanel = (state: AppState) => state.editCompanyLayout.activePanel;
